// MODULES
import {
  nextDispatchOrderPage,
  prevDispatchOrderPage,
  resetDispatchOrderStep,
} from "../../store/reducers/create-dispatch-step";
// HOOKS
import { useAppDispatch, useAppSelector } from "../../hooks/redux";
// COMPONENTS
import Navbar from "../../components/app/Navbar";
import OrderRide from "../../components/create-dispatch/order-ride";
import ShipmentDetails from "../../components/create-dispatch/shipment-details";
import GoodsDetails from "../../components/create-dispatch/goods-details";
import RideSummary from "../../components/create-dispatch/ride-summary";
import AgentSearch from "../../components/create-dispatch/agent-search";
// IMAGES
import map from "../../assets/map.png";
import back from "../../assets/back.png";
import DriverArriving from "../../components/create-dispatch/driver-arriving";
import DriverArrived from "../../components/create-dispatch/driver-arrived";
import DriverOngoing from "../../components/create-dispatch/driver-ongoing";

export default function SendPackage() {
  const dispatch = useAppDispatch();
  const step = useAppSelector((state) => state.createDispatchStep);
  function changeStep() {
    dispatch(nextDispatchOrderPage());
  }
  function resetDispatchStep() {
    dispatch(resetDispatchOrderStep());
  }
  return (
    <div>
      <div>
        <Navbar />
      </div>
      <div className="lg:grid grid-cols-3 gap-5 px-6 lg:px-16 py-6 lg:py-14 max-lg:space-y-7">
        <div>
          {step.value !== 4 && (
            <div onClick={() => dispatch(prevDispatchOrderPage())}>
              <div className="flex items-center py-5 space-x-2 cursor-pointer">
                <img src={back} alt="" className="w-5" />
                <h1 className="font-medium text-lg">Back</h1>
              </div>
            </div>
          )}

          {step.value === 0 && <OrderRide nextDispatchOrderPage={changeStep} />}
          {step.value === 1 && (
            <ShipmentDetails nextDispatchOrderPage={changeStep} />
          )}
          {step.value === 2 && (
            <GoodsDetails nextDispatchOrderPage={changeStep} />
          )}
          {step.value === 3 && (
            <RideSummary nextDispatchOrderPage={changeStep} />
          )}
          {step.value === 4 && (
            <AgentSearch
              resetStep={resetDispatchStep}
              nextDispatchOrderPage={changeStep}
            />
          )}
          {step.value === 5 && <DriverOngoing resetStep={resetDispatchStep} />}
          {/* {step.value === 5 && <DriverArrived resetStep={resetDispatchStep} />} */}
          {/* {step.value === 5 && <DriverArriving resetStep={resetDispatchStep} />} */}
        </div>
        <div className="col-span-2">
          <img src={map} alt="" />
        </div>
      </div>
    </div>
  );
}
